module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b6-1fc05396a34ba2fd236d2cee3a447e34.jpg";